import { Suspense } from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import LoadingIndicator from "./LoadingIndicator";

/**
 * Route-level boundary combining Suspense (loading) + ErrorBoundary (errors).
 * Resets error state automatically on navigation via key={pathname}.
 * Used by all route files as the wrapper for lazy-loaded page components.
 */
export default function QueryBoundary({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  return (
    <ErrorBoundary key={pathname}>
      <Suspense fallback={<LoadingIndicator delay />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}
